export default {"src":"/_next/static/media/ctr.b344299d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};